var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":_vm.label,"items":_vm.options,"multiple":"","hide-details":"","clear-icon":"ic-close","clearable":"","menu-props":{offsetY: true}},on:{"change":_vm.updateValue,"click:clear":_vm.resetValue},model:{value:(_vm.dataSelect),callback:function ($$v) {_vm.dataSelect=$$v},expression:"dataSelect"}})
}
var staticRenderFns = []

export { render, staticRenderFns }